import { useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import { ErpLogFilterForm, ErpLogTable } from 'components/logsErp'
import { Button } from 'components/common'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import { ExportIcon } from 'components/icons'
import { downloadErpLogs } from 'utils/api/logsApi'
import { FILTER_FIELD_ERP_LOG } from 'components/logsErp/erpLogFilterForm'
import { FilterMeta, filterEmptyValues } from 'utils/helpers'
import { useQuery } from 'hooks'

const ErpApi = () => {
  const [filterMeta, setFilterMeta] = useState<FilterMeta>()

  const { getQuery } = useQuery()

  const handleExport = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      const logFilter = filterEmptyValues(getQuery(FILTER_FIELD_ERP_LOG))

      await downloadErpLogs(
        Object.keys(logFilter).length > 0 ? logFilter : undefined,
      )
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | ERP API Logs </title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">ERP API Logs</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <ClearFiltersButton filterKey={FILTER_FIELD_ERP_LOG} />
          <Button
            type="button"
            buttonText="Export"
            variant="custom"
            iconClassName="!h-5 !w-5 text-dataTableIcon"
            icon={<ExportIcon />}
            className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
            onClick={handleExport}
          />
        </div>
      </div>

      <ErpLogFilterForm filterMeta={filterMeta} />
      <ErpLogTable onFilterMeta={setFilterMeta} />
    </>
  )
}

export default ErpApi
